export default 'https://tme.understood.org/assets/outro.en.ba6de243.vtt'